import { render, staticRenderFns } from "./WorkRequestSearchFilter.vue?vue&type=template&id=6b64bfc0&"
import script from "./WorkRequestSearchFilter.vue?vue&type=script&lang=ts&"
export * from "./WorkRequestSearchFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports